export default __webpack_public_path__ + "static/media/arrowRightIcon.de65cedb.svg";